"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const react_window_1 = require("react-window");
const i18n_js_1 = __importDefault(require("i18n-js"));
const withStore_1 = __importDefault(require("../../../../common/decorators/withStore"));
const ListItem_1 = __importDefault(require("./ListItem"));
const BubbleFilter_1 = require("../../../../common/components/Filters/BubbleFilter");
const Loader_1 = __importDefault(require("../../../../common/components/Loader/Loader"));
const DateFilter_1 = __importDefault(require("../../../../common/components/Filters/DateFilter"));
const helpers_1 = require("../../../../common/helpers/helpers");
const ActivityListWrapper = styled_components_1.default.div `
  width: 100%;
  background: #fff;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;
const ActivityList = styled_components_1.default.div `
  height: 100%;

  .list-item {
    width: 100%;
    border-bottom: 1px solid #d5d5d5;
    margin: 0 16px 0px;

    @media (min-width: 600px) {
      margin: 0 32px 0px;
    }

    @media (min-width: 1240px) {
      margin: 0 200px 0px;
    }

    .list-item-img-container {
      img {
        width: 140px;
      }
    }

    .list-item-content {
      padding-top: 2px;
    }
  }
`;
const Filters = styled_components_1.default.div `
  @media (orientation: portrait) {
    order: 2;
  }

  .interest-filter-list,
  .carousel-wrapper {
    margin: 0;

    @media (min-width: 1240px) {
      margin: 0 200px;
    }
  }

  .carousel-wrapper {
    position: relative;
  }

  .interest-filter-list {
    .interest-filter {
      .interest-filter-icon {
        width: 6vmin;
        height: 6vmin;
      }
    }
    
    .filter-name {
      @media (min-width: 1240px) {
        font-size: 2vmin;
      }
    }
  }

  .date-filter-list {
    width: 100%;
    height: 50px;
    padding: 0 !important;
    margin: 0 auto;
  }
`;
const NoItems = styled_components_1.default.div `
  width: 100%;
  height: 92vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3vmin;
`;
const DateTitleElement = styled_components_1.default.p `
  height: 100%;
  margin: 0;
  display: flex;
  align-items: flex-end;
  font-size: 1.8rem;

  padding: 0 16px;

  @media (min-width: 600px) {
    padding: 0 32px;
  }

  @media (min-width: 1240px) {
    padding: 0 200px;
  }
`;
const ActivitiesList = (props) => {
    const { activities, timezone, filters, updateStore } = props;
    const [filteredActivities, setFilteredActivities] = (0, react_1.useState)([]);
    const [selectedFilter, setSelectedFilter] = (0, react_1.useState)({
        id: 0,
        interests: [],
        name: '',
        iconUrl: null,
    });
    const [filtersHeight, setFiltersHeight] = (0, react_1.useState)(0);
    const [userScrolledToDate, setUserScrolledToDate] = (0, react_1.useState)(helpers_1.Helpers.convertDateToTimezone(new Date().toString(), timezone, {
        dateStyle: 'short',
    }));
    const [showList, setShowList] = (0, react_1.useState)(true);
    const [isLoaded, setIsLoaded] = (0, react_1.useState)(false);
    const filtersRef = (0, react_1.useRef)(null);
    const listRef = (0, react_1.useRef)(null);
    const handleOpenDialog = (0, react_1.useCallback)((content) => {
        updateStore('isDialogOpen', true);
        updateStore('dialogContent', content);
    }, [updateStore]);
    const Row = (0, react_1.memo)(({ data, index, style }) => (react_1.default.createElement("div", { style: Object.assign(Object.assign({}, style), { padding: 0, display: 'flex', alignItems: 'center' }) }, // eslint-disable-next-line react/prop-types
    data[index].isDateTitle ? (
    // eslint-disable-next-line react/prop-types
    react_1.default.createElement(DateTitleElement, null, data[index].displayText)) : (react_1.default.createElement(ListItem_1.default, { onListItemClick: handleOpenDialog, content: data[index], withLazyLoad: false, withProgressiveImage: false })))), react_window_1.areEqual);
    const dateFilterEndDate = activities.length > 0 ? activities[activities.length - 1].start : new Date();
    const numberOfDaysToBeDisplayed = Math.ceil(helpers_1.Helpers.getDaysBetweenDates(new Date(), new Date(dateFilterEndDate)));
    const filteredActivitiesWithDateTitles = (0, react_1.useMemo)(() => groupActivitiesByDate(filteredActivities, timezone), [
        filteredActivities,
    ]);
    (0, react_1.useEffect)(() => {
        if (filtersRef && filtersRef.current) {
            const dateFilterHeight = 50;
            setFiltersHeight(filtersRef.current.clientHeight + dateFilterHeight);
        }
        setFilteredActivities(props.activities);
        setIsLoaded(true);
    }, [props.activities]);
    const getCorrectDateInTimezone = (date) => helpers_1.Helpers.convertDateToTimezone(date, timezone, { dateStyle: 'short' });
    const onItemsRendered = ({ visibleStartIndex }) => {
        const firstActivityShown = filteredActivitiesWithDateTitles[visibleStartIndex]
            ? filteredActivitiesWithDateTitles[visibleStartIndex]
            : filteredActivitiesWithDateTitles[0];
        const newUserScrolledToDate = getCorrectDateInTimezone(firstActivityShown.start);
        if (userScrolledToDate !== newUserScrolledToDate) {
            // changing date handled here
            setUserScrolledToDate(newUserScrolledToDate);
        }
    };
    const filterActivitiesByDate = (selectedDate) => {
        const correctDate = helpers_1.Helpers.convertDateToTimezone(selectedDate.date.toString(), timezone, { dateStyle: 'short' });
        const firstActivityInSelectedDate = filteredActivitiesWithDateTitles.findIndex((activity) => helpers_1.Helpers.convertDateToTimezone(activity.start, timezone, {
            dateStyle: 'short',
        }) === correctDate);
        if (listRef && listRef.current) {
            listRef.current.scrollToItem(firstActivityInSelectedDate, 'start');
        }
    };
    const doesActivityBelongToInterest = (activity, selectedInterest) => activity.interestIds.filter(interest => selectedInterest.interests.indexOf(interest) !== -1).length > 0;
    const filterActivitiesByInterest = (selectedInterest) => {
        const differentFilterIsClicked = selectedInterest !== selectedFilter;
        let newFilteredActivities = activities;
        if (differentFilterIsClicked) {
            newFilteredActivities = activities.filter((activity) => doesActivityBelongToInterest(activity, selectedInterest));
        }
        setFilteredActivities(newFilteredActivities);
        setSelectedFilter(differentFilterIsClicked
            ? selectedInterest
            : {
                id: 0,
                interests: [],
                name: '',
                iconUrl: null,
            });
        setUserScrolledToDate(getCorrectDateInTimezone(new Date().toString()));
        if (listRef && listRef.current) {
            listRef.current.scrollToItem(0, 'start');
        }
        // using this to trick react window into re-rendering the activity list, swithing filters caused layout problems in the list probably because of some index handling in the library
        setShowList(false);
        setTimeout(() => {
            setShowList(true);
        }, 100);
    };
    const listHeight = window.innerHeight >= window.innerWidth
        ? window.innerHeight - filtersHeight - window.innerHeight * 0.16
        : window.innerHeight - 0.01 * window.innerHeight - filtersHeight;
    const renderActivityList = () => {
        if (!filteredActivities.length) {
            return react_1.default.createElement(NoItems, null, i18n_js_1.default.t('no_items'));
        }
        if (!showList) {
            return null;
        }
        return (react_1.default.createElement(ActivityList, { filtersHeight: filtersHeight },
            react_1.default.createElement(react_window_1.VariableSizeList, { ref: listRef, height: listHeight, itemCount: filteredActivitiesWithDateTitles.length, itemData: filteredActivitiesWithDateTitles, itemSize: index => (filteredActivitiesWithDateTitles[index].isDateTitle ? 60 : 170), width: "100%", onItemsRendered: onItemsRendered, overscanCount: 2 }, Row)));
    };
    return (react_1.default.createElement(ActivityListWrapper, { filtersHeight: filtersHeight },
        react_1.default.createElement(Filters, { id: "filters", ref: filtersRef },
            react_1.default.createElement(BubbleFilter_1.BubbleFilter, { filters: filters, selectedFilter: selectedFilter, filterActivitiesByInterest: filterActivitiesByInterest }),
            filteredActivities.length > 0 && (react_1.default.createElement(DateFilter_1.default, { filterActivitiesByDate: filterActivitiesByDate, numberOfDays: numberOfDaysToBeDisplayed, userScrolledToDate: userScrolledToDate, setUserScrolledToDate: setUserScrolledToDate }))),
        isLoaded ? react_1.default.createElement(react_1.default.Fragment, null, renderActivityList()) : react_1.default.createElement(Loader_1.default, null)));
};
function groupActivitiesByDate(activities, timezone) {
    const daysDisplayed = [];
    const groupedActivities = [];
    activities.map(activity => {
        const displayText = helpers_1.Helpers.getWeekdayDateAndMonth(activity.start, timezone);
        if (!daysDisplayed.includes(displayText)) {
            daysDisplayed.push(displayText);
            groupedActivities.push({
                isDateTitle: true,
                displayText,
                start: activity.start,
                groupNumber: daysDisplayed.length - 1,
                videos: [],
            });
        }
        groupedActivities.push(Object.assign({}, activity, { groupNumber: daysDisplayed.length - 1 }));
        return null;
    });
    return groupedActivities;
}
const mapStoreToProps = store => ({
    activities: store.getValue('unfilteredActivities'),
    filters: store.getValue('bubbleFilters'),
    backofficeSettings: store.getValue('backofficeSettings'),
    timezone: store.getValue('timezone'),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(ActivitiesList));
